import {
  ControlModeTemplateField,
  ControlModeTemplateFieldsType,
  IStringInputFieldControlModeTemplate,
  INumberInputFieldControlModeTemplate,
  IBooleanInputFieldControlModeTemplate,
  ISelectInputFieldControlModeTemplate,
} from '@src/types/ControlModes';

export const createField = (
  fieldData: {
    uiLabel: string;
    controllerField: string;
    type: ControlModeTemplateFieldsType;
    quickConfig: boolean;
    defaultValue: string | number | boolean | null | undefined;
    range?: { min: number; max: number } | {};
  },
  parsedOptions: string[] = [],
): ControlModeTemplateField => {
  switch (fieldData.type) {
    case ControlModeTemplateFieldsType.STRING: {
      // Only include string-specific properties - no listOptions or range
      const stringField: IStringInputFieldControlModeTemplate = {
        uiLabel: fieldData.uiLabel,
        controllerField: fieldData.controllerField,
        quickConfig: fieldData.quickConfig,
        type: ControlModeTemplateFieldsType.STRING,
      };

      if (
        fieldData.defaultValue !== undefined &&
        fieldData.defaultValue !== null &&
        fieldData.defaultValue !== ''
      ) {
        stringField.defaultValue = String(fieldData.defaultValue);
      }

      return stringField;
    }
    case ControlModeTemplateFieldsType.NUMBER: {
      // Only include number-specific properties - include range but no listOptions
      const numberField: INumberInputFieldControlModeTemplate = {
        uiLabel: fieldData.uiLabel,
        controllerField: fieldData.controllerField,
        quickConfig: fieldData.quickConfig,
        type: ControlModeTemplateFieldsType.NUMBER,
      };

      if (fieldData.range) {
        numberField.range = fieldData.range;
      }

      if (
        fieldData.defaultValue !== undefined &&
        fieldData.defaultValue !== null
      ) {
        // Ensure defaultValue is a number
        numberField.defaultValue = Number(fieldData.defaultValue);
      }

      return numberField;
    }
    case ControlModeTemplateFieldsType.BOOLEAN: {
      // Only include boolean-specific properties - no listOptions or range
      const booleanField: IBooleanInputFieldControlModeTemplate = {
        uiLabel: fieldData.uiLabel,
        controllerField: fieldData.controllerField,
        quickConfig: fieldData.quickConfig,
        type: ControlModeTemplateFieldsType.BOOLEAN,
      };

      if (
        fieldData.defaultValue !== undefined &&
        fieldData.defaultValue !== null
      ) {
        // Ensure defaultValue is a boolean
        booleanField.defaultValue = fieldData.defaultValue === 'true';
      }

      return booleanField;
    }
    case ControlModeTemplateFieldsType.SELECT: {
      // Use the parsed options directly
      if (parsedOptions.length === 0) {
        throw new Error('Select field requires at least one option');
      }

      // Only include select-specific properties - include listOptions but no range
      const selectField: ISelectInputFieldControlModeTemplate = {
        uiLabel: fieldData.uiLabel,
        controllerField: fieldData.controllerField,
        quickConfig: fieldData.quickConfig,
        type: ControlModeTemplateFieldsType.SELECT,
        listOptions: parsedOptions,
      };

      if (
        fieldData.defaultValue !== undefined &&
        fieldData.defaultValue !== null &&
        fieldData.defaultValue !== ''
      ) {
        // Ensure defaultValue is a string
        selectField.defaultValue = String(fieldData.defaultValue);
      } else if (parsedOptions.length > 0) {
        selectField.defaultValue = parsedOptions[0];
      }

      return selectField;
    }
    default:
      throw new Error(`Unsupported field type: ${fieldData.type}`);
  }
};
